<ion-card class="app-background ion-padding">
  <form [formGroup]="professionalDetailsForm" (ngSubmit)="submitDetails()">
    <ion-grid class="ion-padding">
      <ion-row class="ion-text-center">
        <ion-col size="12">
          <ion-label class="panel-header-text" color="dark">
            {{ 'register_step2Title' | translate }}
          </ion-label>
        </ion-col>
      </ion-row>

      <ion-row class="ion-margin-top">
        <ion-col size="12">
          <ion-label class="panel-label-text"
            >{{ 'register_companyName' | translate }}*</ion-label
          >
          <ion-input
            fill="outline"
            formControlName="companyname"
            class="ion-margin-top"
          ></ion-input>
        </ion-col>
        <ion-col size="12" class="ion-padding-top">
          <ion-label class="panel-label-text"
            >{{ 'register_vatNo' | translate }}*</ion-label
          >
          <ion-input
            fill="outline"
            formControlName="vatno"
            class="ion-margin-top"
          ></ion-input>
        </ion-col>
      </ion-row>

      <ion-row class="ion-padding-top">
        <ion-col size="12">
          <ion-label class="panel-label-text"
            >{{ 'register_street' | translate }}*</ion-label
          >
          <ion-input
            fill="outline"
            formControlName="streetNr"
            class="ion-margin-top"
            [class.is-invalid]="
              formHelper.isFieldValidCss('streetNr', isFormSubmitAttempted())
            "
          >
          </ion-input>
        </ion-col>
      </ion-row>

      <ion-row class="ion-padding-top">
        <ion-col size="4">
          <ion-label class="panel-label-text"
            >{{ 'register_postalcode' | translate }}*</ion-label
          >
          <ion-input
            fill="outline"
            formControlName="postalCode"
            class="ion-margin-top"
          ></ion-input>
        </ion-col>
        <ion-col size="8">
          <ion-label class="panel-label-text"
            >{{ 'register_city' | translate }}*</ion-label
          >
          <ion-input
            fill="outline"
            formControlName="city"
            class="ion-margin-top"
          ></ion-input>
        </ion-col>
      </ion-row>

      <ion-row class="ion-padding-top">
        <ion-col size="6">
          <ion-label class="panel-label-text"
            >{{ 'register_country' | translate }}*</ion-label
          >
          <ion-item lines="none" class="ion-margin-top custom-selectable-item">
            @if (countriesData()) {
              <ionic-selectable
                formControlName="country"
                [items]="countriesData()"
                itemValueField="id"
                itemTextField="name"
                [canSearch]="true"
              >
              </ionic-selectable>
            }
          </ion-item>
        </ion-col>
        <ion-col size="6">
          <ion-label class="panel-label-text"
            >{{ 'register_language' | translate }}*</ion-label
          >
          <ion-item lines="none" class="ion-margin-top custom-selectable-item">
            @if (languageData()) {
              <ionic-selectable
                formControlName="language"
                [items]="languageData()"
                itemValueField="id"
                itemTextField="name"
                [canSearch]="true"
              >
              </ionic-selectable>
            }
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row class="ion-margin-top">
        <ion-col size="12" size-lg="10">
          <ion-item lines="none" class="transparent-item">
            <ion-checkbox
              formControlName="terms"
              label-placement="end"
              justify="start"
            >
              <span [innerHTML]="'register_terms' | translate"></span>
            </ion-checkbox>
          </ion-item>
          <div
            class="termsInfo ion-padding-start"
            [innerHTML]="'register_termsInfo' | translate"
          ></div>
        </ion-col>
      </ion-row>

      <ion-row class="ion-margin-top ion-align-items-center">
        <ion-col size="6">
          <ion-button fill="clear" (click)="goBack()">
            <ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon>
          </ion-button>
        </ion-col>
        <ion-col size="6" class="ion-text-right">
          <ion-button
            type="submit"
            color="primary"
            [disabled]="professionalDetailsForm.invalid"
          >
            {{ 'register_next' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-card>
